// ============================================================
// SpeedmasterCore.ScrollReveal
//
// Subtle fade-up-on-scroll for images and videos in blog posts.
// Apple Newsroom-style: elements start invisible + shifted 24px
// down, then fade to full opacity and slide to final position
// when they enter the viewport.
//
// CSS handles the transition (opacity, transform). This module
// adds .sm-revealed when IntersectionObserver fires.
//
// Self-executing AMD module — no manual init needed.
// MutationObserver auto-detects blog post content after SPA nav.
// ============================================================

define('SpeedmasterCore.ScrollReveal', [
	'underscore'
], function (_) {
	'use strict';

	var SELECTOR = '.sc-blog-component-content > div:not(.sc-blog-layout-dynamic-cms-area) img, ' +
	               '.sc-blog-component-content > div:not(.sc-blog-layout-dynamic-cms-area) iframe, ' +
	               '.sc-blog-layout-dynamic-cms-area img, ' +
	               '.sc-blog-layout-dynamic-cms-area iframe';

	var THRESHOLD = 0.15; // trigger when 15% visible

	var observer = null;

	function initObserver() {
		if (observer) {
			return;
		}

		observer = new IntersectionObserver(function (entries) {
			for (var i = 0; i < entries.length; i++) {
				if (entries[i].isIntersecting) {
					entries[i].target.classList.add('sm-revealed');
					observer.unobserve(entries[i].target);
				}
			}
		}, {
			threshold: THRESHOLD
		});
	}

	function observeElements() {
		var elements = document.querySelectorAll(SELECTOR);

		for (var i = 0; i < elements.length; i++) {
			if (!elements[i].hasAttribute('data-sm-reveal')) {
				elements[i].setAttribute('data-sm-reveal', 'true');
				observer.observe(elements[i]);
			}
		}
	}

	// --- Bootstrap ---

	initObserver();

	// Watch for blog content appearing in DOM (SPA navigation)
	var domObserver = new MutationObserver(_.debounce(function () {
		observeElements();
	}, 200));

	domObserver.observe(document.body, {
		childList: true,
		subtree: true
	});

	// Initial scan
	setTimeout(observeElements, 300);
});
